import { Injectable, OnDestroy } from "@angular/core";
import { BaseSiteService } from "@spartacus/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { USJB2BPortalConfig } from "../../shared/constant/storefront-config";

@Injectable({
  providedIn: 'root',
})
export class UDXStorefrontConfigService implements OnDestroy {
  usjfeature = false;
  private destroy$ = new Subject<void>();
  constructor(private baseSiteService: BaseSiteService) {
    this.init();
  }
  private init(): void {
    this.baseSiteService
      .getActive()
      .pipe(takeUntil(this.destroy$))
      .subscribe((currentSite) => {
        const config = USJB2BPortalConfig.find(
          (c) => c.baseSiteId === currentSite
        );
        this.usjfeature = config?.active ?? false;
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
